<app-letter-view
  [clientName]="clientName()"
  [listOffers]="listOffers()"
  (goToOffer)="goToOffer($event)"
  [isErrorRequest]="isErrorRequest()"
  [errorMessage]="errorMessage()"
  [isConfirmedOfferForCurrentUser]="isConfirmedOfferForCurrentUser()" />
